// Matches turbo-rails' hotwire_native_app? — the WebView's UA always contains
// this even when the SW has cached a web-mode page, so it's the reliable signal.
function isHotwireNativeApp() {
    return /(Turbo|Hotwire) Native/.test(navigator.userAgent)
}

async function registerServiceWorker() {
    if (!navigator.serviceWorker) return

    // Hotwire Native apps must NOT use the PWA service worker. The SW caches
    // pages and serves them back to the WebView, which drops the native context
    // (e.g. `<html data-hotwire-native-app>`) and breaks `hotwire_native_app?`
    // behavior — most visibly, native modals (`modal_link_to` falls back to a
    // Turbo-frame fetch instead of a `_top` visit). iOS's WKWebView ignores
    // service workers, but Android's WebView honors them, so we explicitly opt
    // out here and tear down any SW + caches a previous build registered.
    if (isHotwireNativeApp()) {
        try {
            const registrations = await navigator.serviceWorker.getRegistrations()
            await Promise.all(registrations.map((registration) => registration.unregister()))

            if (window.caches) {
                const keys = await caches.keys()
                await Promise.all(keys.map((key) => caches.delete(key)))
            }
        } catch (error) {
            console.error('Failed to tear down service worker for native app:', error)
        }
        return
    }

    try {
        await navigator.serviceWorker.register('/service-worker.js')
    } catch (error) {
        console.error('Failed to register service worker:', error)
    }
}

async function requestNotificationPermission() {
    const permissionResult = await Notification.requestPermission();
    if (Notification.permission === "granted") {
        allowButton.style.display = 'none';
        return true
    }
}

async function startServiceWorker() {
    const vapidPublicKey = document.head.querySelector("meta[name='vapid-public-key']").getAttribute("content")
    console.log(vapidPublicKey)
    await registerServiceWorker()

    if (await requestNotificationPermission()) {
        const subscription = await getPushSubscription(vapidPublicKey)
        await sendSubscriptionToServer(subscription)
    }
}

async function getPushSubscription(vapidPublicKey) {
    const registration = await navigator.serviceWorker.getRegistration()
    if (!registration) return null

    const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: vapidPublicKey
    })
    return subscription
}

async function sendSubscriptionToServer(subscription) {
    return fetch("/notifications/subscribe", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]").getAttribute("content")
        },
        body: JSON.stringify({worker: subscription.toJSON()})
    })
}

async function serviceWorkerUpdate() {
    const registration = await navigator.serviceWorker.ready;

    registration.addEventListener("updatefound", event => {
        const newSW = registration.installing;
        newSW.addEventListener("statechange", event => {
            if (newSW.state == "installed") {
                // New service worker is installed, but waiting activation
            }
        });
    })
}

registerServiceWorker()

// Add this function to handle dismissal
function dismissNotificationsAlert() {
    allowAlert.style.display = 'none';
    // Store the preference in localStorage
    localStorage.setItem('notificationsAlertDismissed', 'true');
}


const allowButton = document.getElementById('allow-notifications');
const allowAlert = document.getElementById('allow-notifications-alert');
const dismissButton = document.createElement('a');

// Configure the dismiss button
dismissButton.href = "#";
dismissButton.className = "whitespace-nowrap font-medium text-blue-700 hover:text-blue-600";
dismissButton.innerText = "Dismiss";
dismissButton.addEventListener('click', (e) => {
    e.preventDefault();
    dismissNotificationsAlert();
});


if (typeof Notification !== "undefined") {
    // Check if user has previously dismissed the alert
    if (localStorage.getItem('notificationsAlertDismissed') === 'true') {
        allowAlert.style.display = 'none';
    } else if (Notification.permission === "granted") {
        allowAlert.style.display = 'none';
        startServiceWorker();
    } else if (Notification.permission === "denied") {
        allowAlert.style.display = 'none';
    } else {
        allowAlert.style.display = 'block';

        // Add the dismiss button to the alert
        const actionContainer = allowButton.parentElement;
        actionContainer.appendChild(dismissButton);
    }

    allowButton.addEventListener('click', async () => {
        if (await requestNotificationPermission()) {
            startServiceWorker();
            allowAlert.style.display = 'none';
        }
    })
}

// Function to reset the dismissed state
function resetNotificationAlert() {
    localStorage.removeItem('notificationsAlertDismissed');
    if (Notification.permission !== "granted" && Notification.permission !== "denied") {
        allowAlert.style.display = 'block';
    }
}

document.getElementById('notification-settings')?.addEventListener('click', (e) => {
    e.preventDefault();
    resetNotificationAlert();
});
